export enum EnumTipoSuministro {
  Gas = 1,
  Luz,
  LuzyGas
}
